export type ClientAppId = 'customer' | 'insurer' | 'super-admin' | 'fitter';
